import { createFileRoute } from "@tanstack/react-router";
import { LiftBrowser } from "@/features/sessions";

/**
 * PICK A LIFT — pushed from the add-work sheet's `Browse` (frame `5a`).
 *
 * ⚠️ A PUSHED SCREEN AND NOT A SECOND SHEET, which is the design system's own rule read the way
 * it is written: a sheet resolves a SINGLE decision, and browsing goes deeper via navigation.
 * The sheet it comes from is three curated offers and one tap; this is two sets of tabs over a
 * list somebody reads before choosing. The shape picker (`/shape`) is the same shape and made
 * the same call.
 *
 * SINGULAR `/lift` AND NOT `/lifts`, because the URL names what the athlete is CHOOSING — the
 * lift their session gains — and not the library it is chosen from. The same rule `/shape`
 * states: a route is a screen, not a domain.
 *
 * ⚠️ IT IS A SIBLING OF THE SESSION SCREEN AND NOT A CHILD OF IT. `_app.session.$id.index.tsx`
 * takes the index position precisely so that `strength`, `timer`, `debrief` — and now this —
 * address themselves rather than rendering inside the session screen as its layout.
 *
 * ⚠️ NO SLOT IN THE PATH. There is no accessory browse and the service publishes none: an
 * accessory offer is a set of drills sized to a number of minutes rather than a movement
 * anybody picks off a list. A parameter that only ever holds one value is a parameter somebody
 * eventually passes the other one.
 *
 * The screen owns its own header bar, the way every pushed screen in this app does.
 */
export const Route = createFileRoute("/_app/session/$id/lift")({
  component: LiftScreen,
});

function LiftScreen() {
  const { id } = Route.useParams();

  return <LiftBrowser sessionId={id} />;
}
